// Данные Балансировщика для показа правил замены по utm-фразе.
// Один запрос на всё время жизни SPA: правила — справочные данные,
// перезагружать их на каждый клик незачем.
import axios from 'axios';

const hostApi = process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'http://localhost:5001';

let indexPromise = null;

export function normalizePhrase(phrase) {
  return String(phrase == null ? '' : phrase).trim().toLowerCase();
}

export function buildIndex(records) {
  const map = new Map();
  for (const record of records || []) {
    for (const phrase of record.utm || []) {
      const key = normalizePhrase(phrase);
      if (!key) continue;
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(record);
    }
  }
  return map;
}

// Только замены текста и HTML — правила «Скрыть блок» намеренно отбрасываются,
// в модалке они не нужны. Признак типа тот же, что у toRules в
// components/balansir/BalansirEditor.vue (непустой innerHTML → HTML, иначе текст),
// поэтому текстом и HTML правило считается одинаково здесь и в редакторе.
// Набор строк с редактором при этом не совпадает: там hidden-правила показываются.
export function extractReplaceRules(blockReWrite) {
  return (blockReWrite || [])
    .filter(item => !item.hidden)
    .map(item => item.innerHTML
      ? { selector: item.elementSelectorAll || '', type: 'HTML', value: item.innerHTML }
      : { selector: item.elementSelectorAll || '', type: 'Текст', value: item.text || '' });
}

export function getBalansirIndex() {
  if (!indexPromise) {
    indexPromise = axios.post(hostApi + '/api/v1/balansir/get', {})
      .then(response => buildIndex(response.data && response.data.data))
      .catch(error => {
        // Иначе кнопка «Повторить» упиралась бы в закэшированную ошибку.
        indexPromise = null;
        throw error;
      });
  }
  return indexPromise;
}
